module.exports = __webpack_public_path__ + "static/media/jasper-43.a865fd9b.jpg";